import { Controller } from "@hotwired/stimulus"

// After the menu opens, scroll it so the current season is visible.
export default class extends Controller {
  scrollSelectedIntoView() {
    const menu = this.element.querySelector(".dropdown-menu")
    const selectedOption = menu?.querySelector(".season-select__option.is-selected")
    if (!menu || !selectedOption) return

    const selectedTop = selectedOption.getBoundingClientRect().top - menu.getBoundingClientRect().top + menu.scrollTop
    const centeredScroll = selectedTop - (menu.clientHeight / 2) + (selectedOption.offsetHeight / 2)
    const maximumScroll = Math.max(0, menu.scrollHeight - menu.clientHeight)
    menu.scrollTop = Math.min(Math.max(0, centeredScroll), maximumScroll)
  }
}
